// Generated by ReScript, PLEASE EDIT WITH CARE


var imgBikeUpper = "/green-mobility/images/fiets_hoog.png";

var imgBikeLower = "/green-mobility/images/fiets_laag.png";

export {
  imgBikeUpper ,
  imgBikeLower ,
}
/* No side effect */
